module.exports = __webpack_public_path__ + "static/media/HT_Cover_Art.59de0406.png";